import psl_ui from '../../libs/psl_ui.js';

import template from './template.pst';

import './style.scss';

psl_ui.templates.add('component_message',template);

const {el}=psl_ui.templates.render('component_message');

const HIDE_DELAY = 100;

let _timer;

const _show = async (msg) => {
	document.body.appendChild(el);
	el.innerHTML=msg;
	el.setAttribute('aria-label',msg);

	if(_timer) clearTimeout(_timer);

	_timer = setTimeout(_hide,HIDE_DELAY);
}

const _hide = async () => {
	document.body.removeChild(el);
	el.innerHTML='';
	el.setAttribute('aria-label','');
}

const _ext={
	hide:_hide,
	show:_show,
};

window.__alert=_ext

export default _ext;
